export default function sliceUrl(index, hash) {
  const params = new URLSearchParams(hash);
  const page = params.get("page") ?? 0;
  const order = params.get("order");
  const orderby = params.get("orderby");

  return new URLSearchParams({
    page,
    order,
    orderby,
  });
}
